module.exports = __webpack_public_path__ + "h5/img/statis4.76cbbd93.png";